// React
import React from 'react';

// Vendors
import { EnsoSpinner } from '@equisoft/design-elements-react';

// Styles
import classes from './PageLoader.module.scss';

const PageLoader = () => {
    return (
        <div className={classes.Root}>
            <EnsoSpinner />
        </div>
    );
};

export default PageLoader;
